export default "__VITE_ASSET__BQ_JiRJ7__"